import React from 'react';

function CareerMain() {
  return (
    <>
  <section className="about-section padding">
    <div className="container">
      <div className="row">
        <div className="col-lg-5">
          <div className="about-img-wrap mt-50">
            <img
              className="wow fade-in-left"
              data-wow-delay="100ms"
              src="assets/img/content-bg-5.jpg"
              alt="img"
            />
          </div>
        </div>
        <div className="col-lg-7">
          <div className="section-heading mb-40">
           
            <h2
              className="text-anim"
              data-effect="fade-in-right"
              data-split="char"s
              data-delay="0.3"
              data-duration={1}
            >
             Join Our Team of IT Experts
            </h2>
            <p
              className="text-anim"
              data-effect="fade-in-bottom"
              data-ease="power4.out"
            >
            At <span style={{color : '#0A0909', fontWeight : 'bold'}}>TITA Technologies</span>, we believe that the key to our success is the talent and expertise of our team. Our mission is to provide top-tier IT services that drive our clients' success, and we are constantly seeking passionate, skilled professionals to join us in this endeavor.
            </p>
          </div>
          <ul className="promo-list mb-30 row">
            <li className="col-md-6 wow fade-in-bottom" data-wow-delay="100ms">
              <i className="fa-solid fa-lightbulb" />
              <div className="promo-content">
                <h3>Drive Innovation</h3>
                <p>
                Join us today and be the leader of tomorrow.
                </p>
              </div>
            </li>
            <li className="col-md-6 wow fade-in-bottom" data-wow-delay="300ms">
              <i className="fa-solid fa-bullseye" /> 
              <div className="promo-content">
                <h3>Transform Ideas</h3>
                <p>
                Turn your creativity into impactful solutions.
                </p>
              </div>
            </li>
          </ul>
         
          <ul className="promo-list mb-30 row">
            <li className="col-md-6 wow fade-in-bottom" data-wow-delay="300ms">
              <i className="fa-solid fa-smile" />
              <div className="promo-content">
                <h3>Empower Success</h3>
                <p>
                Help our clients think big and achieve more.
                </p>
              </div>
            </li>
          </ul>
          <ul
            className="check-list mb-20 wow fade-in-bottom"
            data-wow-delay="100ms"
          >
            <li>
              <i className="fa-solid fa-check" />
              <b></b>Advanced tools for expert developers. Precision and efficiency at your fingertips.
            </li>
            <li>
              <i className="fa-solid fa-check" />
              <b></b>Fair pricing for expert developers. Quality and value you can trust.
            </li>
            <li>
              <i className="fa-solid fa-check" />
              <b></b>24/7 support for expert developers. Assistance whenever you need it.
            </li>
          </ul>
     
        </div>
      </div>
    </div>
  </section>
</>

);
}

export default CareerMain;